import React, { useEffect, useState } from "react";
import { Card, Spin, Typography, Row, Col, Tag } from "antd";
import axios from "axios";

const { Text } = Typography;

const CoquillesTable = ({ url }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [lastUpdate, setLastUpdate] = useState(null);

  const fetchData = async () => {
    try {
      const res = await axios.get(url);
      setData(res.data);
      setLastUpdate(new Date().toLocaleTimeString());
    } catch (err) {
      console.error("Erreur lors du chargement :", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!url) return;
    fetchData();
    const interval = setInterval(fetchData, 2000);
    return () => clearInterval(interval);
  }, [url]);

  return (
    <Card
      bordered={false}
      style={{
        width: "100%",
        margin: 0,
        padding: 0,
        background: "#fff",
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        borderRadius: 0,
      }}
      bodyStyle={{
        margin: 0,
        padding: "8px 0",
      }}
      headStyle={{
        display: "none",
      }}
    >
      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", padding: "10px 0" }}>
          <Spin size="large" />
        </div>
      ) : (
        <>
          <Row
            justify="center"
            align="middle"
            gutter={32}
            style={{ textAlign: "center", margin: 0, padding: 0 }}
          >
            <Col>
              <Text strong>Nb coquilles :</Text>{" "}
              <Tag color="blue"   style={{
                color: "#000",
                border: "1px solid #000",
                fontSize: 14,
                padding: "2px 10px",
                borderRadius: 6,
              }}>
                {data?.all ?? 0}
              </Tag>
            </Col>
            <Col>
              <Text strong>Nb coquilles OK :</Text>{" "}
              <Tag color="blue"   style={{
                color: "#000",
                border: "1px solid #000",
                fontSize: 14,
                padding: "2px 10px",
                borderRadius: 6,
              }}>
                {data?.ok ?? 0}
              </Tag>
            </Col>
            <Col>
              <Text strong>Nb coquilles KO :</Text>{" "}
              <Tag color="blue"   style={{
                color: "#000",
                border: "1px solid #000",
                fontSize: 14,
                padding: "2px 10px",
                borderRadius: 6,
              }}>
                {data?.nok ?? 0}
              </Tag>
            </Col>
          </Row>

        </>
      )}
    </Card>
  );
};

export default CoquillesTable;
